export const counterFormat = (number: any) => {
  return number > 9 ? number : `0${number}`;
};
